import angular from 'angular';

import { AppComponent } from './components/app.component';
import { TokenExpiredComponent } from './components/token-expired.component';

import { HttpErrorsObserver } from './services/http-errors-observer.service';

const core = angular.module('core', ['ui.router', 'ui.gravatar', 'commons']);

core.component('app', AppComponent);
core.component('tokenExpired', TokenExpiredComponent);
core.service('HttpErrorsObserver', HttpErrorsObserver);

export const CoreModule = core;